import { authGet, authSet } from '../utils/request';

export const getServiceTokens = (page = 1) => authGet('/service-tokens', { params: { page } })
  .then(({ data }) => data);
export const getServiceTokenUsers = () => authGet('/service-tokens/users').then(({ data }) => data);
export const createServiceToken = (body) => authSet('POST', '/service-tokens', body);
export const revokeServiceToken = (id) => authSet('DELETE', `/service-tokens/${id}`);
